export type TabId =
  | 'dashboard'
  | 'calendar'
  | 'planner'
  | 'recipes'
  | 'ingredients'
  | 'shopping'
  | 'body'
  | 'settings';

export type ThemeName =
  | 'emerald-chef'
  | 'sunset-orange'
  | 'midnight-slate'
  | 'berry-diet'
  | 'nordic-frost'
  | 'olive-garden'
  | 'espresso-cream'
  | 'cyber-lime'
  | 'lavender-herb'
  | 'monochrome-pro';

export const THEME_NAMES: readonly ThemeName[] = [
  'emerald-chef',
  'sunset-orange',
  'midnight-slate',
  'berry-diet',
  'nordic-frost',
  'olive-garden',
  'espresso-cream',
  'cyber-lime',
  'lavender-herb',
  'monochrome-pro',
];

export const DEFAULT_THEME: ThemeName = 'emerald-chef';

export interface NavTab {
  id: TabId;
  label: string;
  icon: string;
}
